import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'persons/person';
const wizardName = 'Car dissociation';
const wizardObject = 'Car';
const wizardAction = 'carDissociation';

const CarDissociation = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);


    // DATA PROVIDER
    const personRecordId = params?.id ?? params?.person?.id ?? params?.person?._id ?? null;
    const {doAction, item, loadOne, errorMessage, errors, saving} = useDataProvider(dataProviderName, params.multipart, personRecordId);
    const person = params?.person ?? item?.data;

    let dsvs = params.defaultSelectedValues;
    if (typeof dsvs == 'string') {
        dsvs = dsvs.split(',').map((dsv) => { return {'_id': dsv}});
    } else if (typeof dsvs == 'undefined') {
        dsvs = [];
    } else{
        dsvs = [dsvs];
    }

    const modelName = existingModules[dataProviderName].modelName
    const detailConfig = {
        "tabs": [
            {
                "name": "dissociation",
                "fieldsets": [
                    {
                        "name": "dissociation",
                        "fields": {
                            "assignment_period": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "assignment_end_at": {
                                "type": "date",
                                "className": "col-12",
                                "placeholder": "insert",
                                "icon": "faCalendarXmark"
                            },
                            "cars_assigned": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "dissociated": {
                                "type": "poollist",
                                "defaultSelectedValues": dsvs,
                                "enableSelection": true,
                                "disableMultipleRowSelection": true,
                                "dataProviderName": "cars/car",
                                "filters": {
                                    "items": [
                                        {
                                            "field": "id", // usa id e non _id perché il server non cerca per ObjectID
                                            "operator": "isAnyOf",
                                            "value": person?.employments?.map((employment) => employment.pools.map((pool) => pool._id)).flat(Infinity)
                                        }
                                    ]
                                },
                                "className": "col-12",
                                "required": "true"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }
    const handleSave = async (data) => {
        doAction && await doAction({ action: wizardAction, model: dataProviderName, data: data });
        loadOne(person?._id ?? person?.id)
        close();
    }

    return <>
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{ "id": person?._id ?? person?.id, "dissociated": dsvs?.map((dsv) => dsv._id) }}
            modelName={modelName}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            editingDefault={true}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName+'.'+wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Remove a {{wizardObject}} from {{firstname}} {{lastname}}', { wizardObject:wizardObject, firstname: person?.firstname, lastname: person?.lastname })}
                />
            }
            {...params}
        />
    </>
}

export default CarDissociation;


